import { jsx as r } from "react/jsx-runtime";
import { observer as c } from "mobx-react-lite";
import { createPortal as i } from "react-dom";
import m from "./chunk630.js";
import { Alert as s } from "./chunk.js";
const h = c(({ store: o }) => {
  const { show: e, message: t, alertType: n, closeSnackbar: a } = o;
  return i(
    /* @__PURE__ */ r("aside", { children: /* @__PURE__ */ r(m, { open: e, children: /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(
      s,
      {
        type: n,
        onClose: a,
        children: t
      }
    ) }) }) }),
    document.body
  );
});
export {
  h as MainSnackbar
};
